import { addDays, format } from 'date-fns'
import type { ShiftAssignment } from '@/types/shift.types'

export function getAssignmentDateKey(
  assignment: ShiftAssignment | null,
): string | null {
  const date = assignment?.date
  if (!date) return null
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(date)
  return match?.[1] ?? null
}

export function getLocalDateKey(date: Date): string {
  return format(date, 'yyyy-MM-dd')
}

export function dateFromKey(dateKey: string): Date {
  const [year, month, day] = dateKey.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function isAssignmentToday(assignment: ShiftAssignment | null): boolean {
  const dateKey = getAssignmentDateKey(assignment)
  return dateKey != null && dateKey === getLocalDateKey(new Date())
}

export function isAssignmentFuture(assignment: ShiftAssignment | null): boolean {
  const dateKey = getAssignmentDateKey(assignment)
  return dateKey != null && dateKey > getLocalDateKey(new Date())
}

export function getAssignmentDateLabel(
  assignment: ShiftAssignment | null,
): string | null {
  const dateKey = getAssignmentDateKey(assignment)
  if (!dateKey) return null
  const today = new Date()
  const todayKey = getLocalDateKey(today)
  if (dateKey === todayKey) return null
  if (dateKey === getLocalDateKey(addDays(today, 1))) {
    return `Tomorrow, ${format(dateFromKey(dateKey), 'd MMM')}`
  }
  if (dateKey === getLocalDateKey(addDays(today, -1))) {
    return `Yesterday, ${format(dateFromKey(dateKey), 'd MMM')}`
  }
  return format(dateFromKey(dateKey), 'EEE, d MMM yyyy')
}

export function getAssignmentLocalDate(
  assignment: ShiftAssignment | null,
): Date | null {
  const dateKey = getAssignmentDateKey(assignment)
  return dateKey ? dateFromKey(dateKey) : null
}
